export default __webpack_public_path__ + "static/media/Allison_Sutter_AHV_In_Moms_We_Trust.1fb62a8a.jpg";